module.exports = __webpack_public_path__ + "img/link.99bfd7d9.png";